module.exports = fox => {
	const $ = fox.jQuery;

	const formValidationMixin = require('./mixin/formvalidation')(fox);
	const socketsReconnectMixin = require('./mixin/socketsReconnect')(fox);

	fox.registerWidget('Common_AutoLoginPopup', fox.mixin({
		configure() {
			this.registerOptions('', {
				preventHideOnShadowClick: true,
				dialog: {
					closeOnEscape: false,
					width: '482px'
				},
				widgets: {
					content: {
						widget: 'Common_LoginForm',
						template: 'common_autologin_popup',
						useCaptcha: true,
						configureApi: () => this.configureApi(),
						prepareParamsCallback: (params) => this.prepareParams(params),
						loginSuccessCallback: (...args) => this.loginSuccess(...args),
						loginFailedCallback: (...args) => this.loginFailed(...args),
						showCaptchaCallback: () => this.showCaptcha()
					}
				},
				'handleWom.formValid': {
					widget: '#content #form',
					event: ['form_valid', 'form_not_valid'],
					callback: (...args) => this.formInvalidate(...args)
				},
				handleDom: {
					submit: {
						target: '#login',
						targetWidget: '#content',
						callback: (button, alias, widget, event) => {
							event.preventDefault();
							
							$(widget.rdom1('.reg-error')).text('').hide();

							$(button).addClass('spin');
							button.disabled = true;

							widget.login({ button }).then(result => {
								if (!result) {
									$(button).removeClass('spin');
									button.disabled = false;
								}

								return result === true && this.__resolver(result);
							});
						}
					},
					cancel: {
						target: ['#cancel', '.cross.close'],
						targetWidget: '#content',
						callback: () => this.__resolver(false)
					},
					focusElement: {
						event: 'focus',
						target: ['input[type=text]', 'input[type=password]'],
						targetWidget: '#content',
						callback: (input, alias, widget) => {
							$(widget.rdom1('.reg-error')).text('').hide();
						}
					}
				}
			});

			this.registerOptions('#content #form', {
				formSelector: '#authorization-form'
			});

			this.callParent('configure', arguments);
		},

		configureApi() {
			return this.getApi('__authorizeApi', {
				httpMethod: 'post',
				method: 'site.authorizer.auth',
				secure: fox.getEnv('ah') && [fox.getEnv('ah').split('').reverse().join(''), fox.getEnv('aet')]
			});
		},

		prepareParams({login, ...rest} = {}) {
			return {
				...rest,
				le: login
			};
		},

		loginSuccess(resp, rest) {
			const member = fox.objectGet(resp, 'answer.response.member');

			if (!member)
				return this.loginFailed(false);

			const { button } = rest;

			$(button).removeClass('spin');
			button.disabled = false;

			if (this.isOpen())
				this.hide();

			member.login = member.login || member.email;
			fox.setEnv('member', { collection: { 0: member } });

			const permissionManager = this.rwom1('@root #permissionManager');
			const { isPremium } = member;
			const promise = this.wait(permissionManager, 'permissions_update').then(resp => {
				return this.reconnectSockets();
			});

			if (isPremium) {
				permissionManager.updatePermissions({
					guest: { enabled: false },
					member: { enabled: true }
				});
			} else {
				permissionManager.updatePermissions({ guest: { enabled: true } });
			}

			return promise.then((result) => {
				this.dispatchEvent('login_succeed');
				return result;
			});
		},

		loginFailed({ params: { answer: { reason }}}, rest) {
			$(this.rwom1('#content').rdom1('.reg-error')).text(reason).show();

			const { button } = rest;

			$(button).removeClass('spin');
			button.disabled = false;

			this.dispatchEvent('login_failed');

			return false;
		},

		show(...args) {
			return new fox.Promise(resolve => {
				this.__resolver = resolve;
				this.callParent('show', args);
			});
		},

		showCaptcha() {
			$(this.rwom1('#content').rdom1('#captchaBlock')).show();
		}
	}, formValidationMixin, socketsReconnectMixin), 'Popup_Common');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/widget/AutoLoginPopup.es.js